import React, {useRef} from "react";
import {createUseStyles} from "react-jss";

const useStyles = createUseStyles({
	lineConnector: {
		width: props => props.width,
		height: props => props.height,
	},
	svg: {
		width: "100%",
		height: "100%",
	},
});

export type LineConnectorProps = {
	width: number
	height: number
	numberOfLines: number
	thickness: number
	color: string
	opacity?: number
}

export default function LineConnector({width, height,numberOfLines, thickness, color, opacity = 1}:LineConnectorProps) {
	const containerRef = useRef(null);
	const classes = useStyles({width,height});
	const lines = [];
	if(width && height) {
		const gap = (width - (numberOfLines * thickness)) / (numberOfLines - 1);
		for(let i = 0; i < numberOfLines; i++) {
			let x = Math.round((thickness / 2) + i * (gap + thickness));
			lines.push(<line key={i} x1={x} y1="0" x2={x} y2={height} style={{stroke:color,strokeWidth:thickness,opacity:opacity}} />);
		}
	}

	return (
		<div className={classes.lineConnector} ref={containerRef}>
			<svg className={classes.svg}>
				{lines}
			</svg>
		</div>

	);


}